import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ImageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"image"}/>
}
